export default __webpack_public_path__ + "static/media/plumbing.9e5f9b67.svg";